/**
 * Defines the constants used by the Properties module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

export const VUEX_PROPERTIES_INIT				        = 'VUEX_PROPERTIES_INIT'
export const VUEX_PROPERTIES_INITIALIZED		        = 'VUEX_PROPERTIES_INITIALIZED'
export const VUEX_PROPERTIES_SET_ALL			        = 'VUEX_PROPERTIES_SET_ALL'

export const VUEX_PROPERTIES_GET_BLACKOUT_DATES         = 'VUEX_PROPERTIES_GET_BLACKOUT_DATES'
export const VUEX_PROPERTIES_GET_BLACKOUT_DATES_SUCCESS = 'VUEX_PROPERTIES_GET_BLACKOUT_DATES_SUCCESS'
export const VUEX_PROPERTIES_GET_BLACKOUT_DATES_FAILURE = 'VUEX_PROPERTIES_GET_BLACKOUT_DATES_FAILURE'